export class DetalhamentoFaturaClienteDesconto {
  id: number;
  descricao: string;
  valor: number;
  tipo: string;

  constructor(detalhamentoFaturaClienteConsulta) {
    this.id = detalhamentoFaturaClienteConsulta['id'] || null;
    this.descricao = detalhamentoFaturaClienteConsulta['descricao'] || 'DESCONTO';
    this.tipo = detalhamentoFaturaClienteConsulta['tipo'] || null;
    this.valor = detalhamentoFaturaClienteConsulta['valor'] || null;
  }

}
